import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchLanguages } from '@app/api'
import { getUserLanguage } from '@app/utils'

export const getLanguagesThunk = createAsyncThunk(
  'languages',
  async () => {
    const userLanguage = getUserLanguage()

    return await fetchLanguages(userLanguage)
  }
)
